import { IEtudiantAdvanced } from "src/app/interfaces/etudiant";
import { IUser } from "src/app/model/user";
import { StorageService } from "src/app/services/common/storage";
import { All, AuthActionTypes } from "../actions/auth.actions";

export interface State {
    // is a user authenticated?
    isAuthenticated: boolean;
    // if authenticated, there should be a user object
    user: IEtudiantAdvanced | null;
    // error message
    errorMessage: string | null;
}

export const initialState: State = {
    isAuthenticated: false,
    user: null,
    errorMessage: null
}
export function reducer(state = initialState, action: All): State {

    const defaultUser: IEtudiantAdvanced = {
        nom: "",
        prenom: "",
        email: "",
        phone: "",
        pays: "",
        type: 0,
        isAdmin: false,
        isAuthenticated: false

    }

    switch (action.type) {

        case AuthActionTypes.LOGIN_SUCCESS: {

            action.localStorage.setItem("user", JSON.stringify(action.payload));
            return {
                isAuthenticated: true,
                user: action.payload,
                errorMessage: null
            };
        }

        case AuthActionTypes.LOGOUT: {

            action.localStorage.clear();
            return {
                errorMessage: null,
                user: defaultUser,
                isAuthenticated: false
            }
        }
        case AuthActionTypes.LOGIN_FAILURE: {
            return {
                ...state,
                errorMessage: 'Email ou mot de passe incorrect'
            }
        }
        default: {
            const t = new StorageService();
            let user: IEtudiantAdvanced = JSON.parse(t.getUserItem());

            if (user) {
                const userSave = user.email ? user : defaultUser;
                t.setItem("user", JSON.stringify(user));
                return {
                    isAuthenticated: true,
                    user: userSave,
                    errorMessage: null
                };

            }

            return {
                ...state,
                user: defaultUser,
                isAuthenticated: false
            }


        }
    }
}